import React, { type FC, Fragment, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LinearProgress } from '@zawarski/eti-ui';
import { SidebarLayout } from 'components/layout';

const MainLayout: FC = () => {
  const location = useLocation();

  return (
    <Fragment>
      <Suspense fallback={<LinearProgress />}>
        <SidebarLayout>
          <Outlet key={location.key} />
        </SidebarLayout>
      </Suspense>
    </Fragment>
  );
};
export default MainLayout;
